import React from "react";
import {
    TextField,
    SelectField,
    ArrayField,
    DateField,
    Datagrid
} from 'react-admin';

class EducationArrayField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <ArrayField {...this.props}>
                <Datagrid>
                    <SelectField label="Країна" source="country" choices={[
                        { id: 'UA', name: 'УКРАЇНА' }
                    ]} />
                    <TextField label="Місто" source="city" />
                    <TextField label="Навчальний заклад" source="institutionName"  />
                    <DateField label="Дата видачі" source="issuedDate" />
                    <TextField label="Номер диплому" source="diplomaNumber" />
                    <SelectField label="Рівень освіти" source="degree"  choices={[
                        { id: 'BACHELOR', name: 'Бакалавр' },
                        { id: 'EXPERT', name: 'Спеціаліст' },
                        { id: 'JUNIOR_EXPERT', name: 'Молодший спеціаліст' },
                        { id: 'MASTER', name: 'Магістр' }
                    ]} />
                    <TextField label="Вказати спеціальність" source="speciality" />
                </Datagrid>
            </ArrayField>
        );
    }
}

export default EducationArrayField;
